import Box from '@zenbusiness/zui/Box';
import DialogContent from '@zenbusiness/zui/DialogContent';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Link from '@zenbusiness/zui/Link';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import { tooltipClasses } from '@zenbusiness/zui/Tooltip';

const DialogContentStyle = ({ theme }) => ({
  paddingTop: '40px !important',
  paddingLeft: 0,
  paddingRight: 0,
  paddingBottom: '100px',
  backgroundColor: theme.palette.background.grey.main,
  [theme.breakpoints.up('md')]: {
    paddingTop: '60px !important'
  }
});

const FieldContainerStyle = ({ theme }) => ({
  padding: '16px 24px',
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.light
});

const RadioGroupStyle = () => ({
  width: '100%',
  gap: '24px'
});

const FormControlLabelStyle = ({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '0px 5px',
  width: 'fit-content',
  '& .MuiFormControlLabel-label': {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginTop: 9
    }
  }
});

const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

const DisableWireBoxStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.grey.main,
  padding: '16px 24px',
  borderRadius: '16px',
  marginTop: '24px'
});

export const LinkStyles = () => ({
  cursor: 'pointer',
  textDecoration: 'underline'
});

export const TextStyle = () => ({
  whiteSpace: 'nowrap'
});

export const TooltipStyle = ({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    ...theme.typography.sm,
    height: 'max-content',
    padding: '8px 14px',
    borderRadius: '12px',
    backgroundColor: theme.palette.fixed.black
  }
});

export const FieldContainerStyled = styled('div')(FieldContainerStyle);
export const RadioGroupStyled = styled(RadioGroup)(RadioGroupStyle);
export const FormControlLabelStyled = styled(FormControlLabel)(FormControlLabelStyle);
export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
export const Wrapper = styled(Stack)(WrapperStyle);
export const DisableWireBoxStyled = styled(Box)(DisableWireBoxStyle);
export const LinkStyled = styled(Link)(LinkStyles);
